var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkDoneCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeMiterlimit: 10,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.42
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 16c0-8.005-6.495-14.5-14.5-14.5C7.995 1.5 1.5 7.995 1.5 16c0 8.005 6.495 14.5 14.5 14.5 8.005 0 14.5-6.495 14.5-14.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.458 11.167l-8.448 9.666-3.621-3.625M11.163 20.833l-3.621-3.625M19.754 11.167l-3.893 4.455",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkDoneCircle);
export default __webpack_public_path__ + "static/media/CheckMarkDoneCircle.d443f99cb8c2420d53aad952b1aeafd0.svg";
export { ForwardRef as ReactComponent };